import { useEffect, useRef } from 'react'
import { BsCurrencyDollar } from 'react-icons/bs'

const PaidFeatureBadge = ({ show }) => {
    const rootElement = useRef()
    
    useEffect(() => {
        
        if (rootElement.current && show) {
            // adds relative position 
            const parent = rootElement.current.parentNode
            
            parent.style.position = 'relative'
        }
        
    }, [show])
    
    return show && ( 
        <div
            ref={rootElement}
            className="
                absolute top-[-6px] bg-white text-[var(--parse-background-lighter)]
                rounded-full right-[-6px] p-[1px]">
            <BsCurrencyDollar />
        </div>
    )
    
}

export default PaidFeatureBadge
